import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import GeneralEditPlaylistForm from "../utils/GeneralEditPlaylistForm";
import useEditPlaylist from "./useEditPlaylist";
import {useParams} from "react-router-dom";
import useLoadPlaylist from "../utils/useLoadPlaylist";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import LastUpdateInfo from "../../../../commons/utils/lastUpdate/LastUpdateInfo";
import {useIntl} from "react-intl";

const EditPlaylistSection = () => {

    // The selected user from the list (provided as parameter)
    const {key} = useParams()

    const {playlist, loading} = useLoadPlaylist(key)

    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the new user functionality
    const {save, saveInProgress, cancel} = useEditPlaylist()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedPlaylistRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({id: 'app.playlists.edit.appbar.header', defaultMessage: 'Edit Playlist'}),
            description: <LastUpdateInfo metadata={playlist?.metadata}/>,
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.playlists.edit.appbar.actions.save',
                        defaultMessage: 'Save'
                    })}
                    onClick={() => save(editedPlaylistRef.current)}
                    icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.playlists.edit.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, playlist, saveInProgress])

    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.playlists.edit.loading', defaultMessage: 'Loading Playlist...'})}/>
    }

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.playlists.edit.save.loading', defaultMessage: 'Saving Playlist...'})}/>
    }

    return (
        <GeneralEditPlaylistForm selectedPlaylist={playlist}
                                 editedPlaylistRef={editedPlaylistRef}
                                 setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default EditPlaylistSection